module.exports = __webpack_public_path__ + "static/media/banner-img5.3266f1d7.jpg";